import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import moment from 'moment';
import ensureInitialized from '../../app/containers/ensureInitialized';
import LoadingScreen from '../../app/LoadingScreen/LoadingScreen';

// Set global moment settings
moment.locale('sv');

window.isConsultPortal = true;

function App({ isLoading, children }) {
  return (
    <div>
      <LoadingScreen
        position="fixed"
        isLoading={isLoading !== 0}
      />
      {children}
    </div>
  );
}

App.propTypes = {
  isLoading: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
};

function mapStateToProps(state) {
  return {
    isLoading: state.get('isLoading'),
  };
}

export default compose(
  ensureInitialized,
  connect(mapStateToProps),
)(App);
